import { ContactUsDto } from "src/data/models/contactUsDtos/contactUsDto.interface";
import { SettingDto } from "src/data/models/settingDtos/settingDto.interface";
import { SliderDto } from "src/data/models/sliderDtos/sliderDto.interface";
import { singleton } from "tsyringe";
import BaseService from "../Base/BaseService";

@singleton()
export class BaseDataService extends BaseService {
  constructor() {
    super();

    this.setMiddlware(this.errorCatcher, [
      "getSetting",
      "editSetting",
      "getSliders",
      "getContactUs",
      "addSlider",
      "editSlider",
      "deleteSlider"

    ]);
    this.setMiddlware(this.handleToken, [
      "getSetting",
      "editSetting",
      
      "getSliders",
      "getContactUs",
      "addSlider",
      "editSlider",
      "deleteSlider"
    ]);
  }

  async getSetting(): Promise<SettingDto> {
    const result = await this.repositoryWrapper.BaseData.getSetting();
    return result.result;
  }

  async editSetting(data: SettingDto): Promise<SettingDto> {
    const result = await this.repositoryWrapper.BaseData.editSetting(data);
    return result.result;
  }
  async getSliders(): Promise<SliderDto[]> {
    const result = await this.repositoryWrapper.BaseData.getSliders();
    return result.result;
  }

  async getContactUs(): Promise<ContactUsDto[]> {
    const result = await this.repositoryWrapper.BaseData.getContactUs();
    return result.result;
  }

  async getSlider(sliderId: any): Promise<SliderDto> {
    const result = await this.repositoryWrapper.BaseData.getSlider(sliderId);
    return result.result;
  }

  async addSlider(data: SliderDto): Promise<SliderDto> {
    const result = await this.repositoryWrapper.BaseData.addSlider(data);
    return result.result;
  }

  async editSlider(data: SliderDto): Promise<SliderDto> {
    const result = await this.repositoryWrapper.BaseData.editSlider(data);
    return result.result;
  }

  async deleteSlider(sliderId: any): Promise<number> {
    const result = await this.repositoryWrapper.BaseData.deleteSlider(sliderId);
    return result.result;
  }

}
